import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { PaginationOptions } from '../../conf/pagination-options.interface';
import { FilterService } from '../../services/filter.service';
import { GlobalService } from '../../services/global.service';
import { MenuService } from '../../services/menu.service';
import { tablefields } from '../../../consts/table-holidays';
import { TimelineService } from 'src/app/timeline/timeline.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-holidays-home',
    templateUrl: './holidays-home.component.html',
    styleUrls: ['./holidays-home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HolidaysHomeComponent implements OnInit {

	currentProject: any = null;
	projectId: any = null;
	headers: any;
	loading: boolean = false;
	view: string = 'home';
	selectedItem: any;
	module: any = {
		'name': null,
		'access': null
	};
	filterArguments: any = {
		'search': '',
	};
	holidays: any[] = [];
	filteredHolidays: any[] = [];
	paginationOptions: PaginationOptions;

	filter(ev?) {
		if (ev) {
			this.changeView('home');
			this.filterArguments = ev
		}
		this.filteredHolidays = JSON.parse(JSON.stringify(this.holidays));
		this.filteredHolidays = this._fS.searchByMultipleValues(this.filteredHolidays, ['date', 'date_pipe', 'title', 'name_esp', 'name_eng'], this.filterArguments.search);
		this.paginationOptions = this._gS.getPagination(`holidays`);
	}

	goBack() {
		if (this.currentProject) {
			if (this.module.name == 'post') {
				this.router.navigate(['/projects', this.currentProject.id, 'post', 'timeline']);
			} else {
				this.router.navigate(['/projects', this.currentProject.id, 'timeline']);
			}
		} else {
			this.router.navigate(['/timeline']);
		}
	}

	getProject() {
		this.loading = true;
		if (this._gS.projectSelected && this._gS.projectSelected.id.toString() == this.projectId.toString()) {
			this.currentProject = this._gS.projectSelected;
			this.loadData();
			return;
		}
		this._pS.getProjectData(this.projectId).subscribe(
			(data: any) => {
				this.currentProject = data.project;
				this.loadData();
			}
		);
	}

	contextItem(ev) {
		this.selectedItem = ev;
	}

	loadData() {
		this.loading = true;
		this.changeView('home');
		this._tS.getHolidays(this.currentProject).subscribe(
			(data: any) => {
				this.holidays = data.hollidays;
				this.holidays.map(h => {
					h.date_pipe = this._dP.transform(h.date, 'MMM-dd-yyyy')
				});
				this.filter();
				this.loading = false;
			}
		)
	}

	changeView(ev) {
		this.view = ev;
	}

	deleteHoliday() {
		this.loading = true;
		this._pS.removeCalendarEvent(this.selectedItem.id, 'holliday').subscribe(
			(data: any) => {
				this.loadData();
			}
		);
	}

	constructor(
		public _gS: GlobalService,
		private router: Router,
		private _dP: DatePipe,
		private route: ActivatedRoute,
		private _mS: MenuService,
		private _pS: ProjetcsService,
		private _fS: FilterService,
		private _tS: TimelineService
	) { }

	ngOnInit() {
		this.route.data.subscribe(data => {
			this.headers = JSON.parse(JSON.stringify(tablefields));
			this.module.name = data.module;
			this.module.access = data.access[0].id;
			this.route.params.subscribe(
				params => {
					if (params.id) {
						this.projectId = params.id;
						this._mS.manualChangeMenu$.next('projects');
						this.getProject();
						return;
					}
					this.loadData();
				}
			);
		});
	}

}
